import { Component, OnDestroy, OnInit } from '@angular/core';
import { BodyService } from '../../services/body.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../services';
import { LandingComponent } from './landing/landing.component';
import { AmbasadorKeeper, IAmbassador } from 'src/helper/ambassadorKeeper';
import { LanguageType } from '../../services/external/config/misc';
@Component({
	selector: 'anon',
	templateUrl: './anon.component.html',
	styleUrls: ['./anon.component.less']
})
export class AnonComponent implements OnInit, OnDestroy {

	mobileMenuShow: boolean = false;
	lang: LanguageType;
	langs: any = LanguageType;

	ambasador: IAmbassador = null;
	hasAmbasador: boolean = false;

	constructor(private bodySrv: BodyService,
		private router: Router,
		private translate: TranslationService,
		private activatedRoute: ActivatedRoute) {
			const ambasador = new AmbasadorKeeper(window);
			this.hasAmbasador = ambasador.hasCurrentAmbassador();			

			if(this.hasAmbasador)
				this.ambasador = ambasador.getAmbassador();

		}

	ngOnDestroy(): void {
		this.bodySrv.deleteAnonymous();
	}

	ngOnInit(): void {
		this.bodySrv.applyAnonymous();
		this.lang = this.translate.lang;

		//let lang = this.activatedRoute.snapshot.paramMap.get("lang");
		//console.log(lang);


	}
	hideMenu = () => {
		this.mobileMenuShow = false;
	} 

	toPrice = () => {
		this.hideMenu();
	//	this.router.navigate(['/'], { fragment: 'pricing', skipLocationChange: true, preserveFragment: false });
		LandingComponent.scrollTo('pricing', true);
	}

	toContacts = () => {
		this.hideMenu();
		LandingComponent.scrollTo('contacts', true);
		//this.router.navigate(['/'], { fragment: 'contacts', skipLocationChange: true });
	}

	onLang(ui: any) {
		const l = ui as LanguageType;
		if (window.location.pathname.startsWith('/tos')
			|| window.location.pathname.startsWith('/privacy')
			|| window.location.pathname.startsWith('/help')) {
			this.translate.applyLang(l, true);
			location.reload();
		} else {
			location.pathname = LanguageType[l];
		}
	}


}
